import axios from 'axios';
import type { ApiResponseError } from './types';

function pickString(v: unknown, fallback: string): string {
  if (v === undefined || v === null) {
    return fallback;
  }
  return String(v);
}

/** Maps axios (and unknown) failures into {@link ApiResponseError}. */
export function toApiResponseError(error: unknown): ApiResponseError {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const raw = error.response?.data;
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
      const d = raw as Record<string, unknown>;
      return {
        code: pickString(d.code, pickString(status, 'HTTP_ERROR')),
        message: pickString(d.message, error.message || 'Request failed'),
        title: pickString(d.title, 'Error'),
      };
    }
    return {
      code: pickString(status, 'HTTP_ERROR'),
      message: error.message || 'Request failed',
      title: 'Error',
    };
  }
  if (error instanceof Error) {
    return {
      code: 'UNKNOWN',
      message: error.message,
      title: 'Error',
    };
  }
  return {
    code: 'UNKNOWN',
    message: 'Request failed',
    title: 'Error',
  };
}
